import { RouterModule, Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LazyLoadEvent, CheckboxModule, SelectItem, MessageService } from 'primeng';
import { IInvoiceAddress } from '../../interfaces/invoice-address';
import { NoEmptyString } from '../../interfaces/no-empty-string.validator';
import { AccountCodeService } from '../../services/account-code.service';
import { MapService } from '../../services/map.service';
import { OrganisationsService } from '../../services/organisations.service';
import { PcaService } from '../../services/pca.service';
import { UserService } from '../../services/user.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TreeModule, TreeNode, ContextMenuModule, MenuItem } from 'primeng';
import { InvoiceAddressService } from '../../services/invoice-address.service';
import { IVehicleLifeCycleProviderConnection } from '../../interfaces/vehicle-life-cycle/vehicle-life-cycle-provider-connection';
import { VehicleLifecycleService } from '../../services/vehicle-lifecycle.service';
import { IVehicleLifeCycleTeamConnection } from '../../interfaces/vehicle-life-cycle/vehicle-life-cycle-team-connection';
import { Message } from '../../classes/Message';
import { integerOrNullValidator } from '../../utils/form-validators/integer-or-null.validator';
import { AddressAutoCompletionService } from 'src/app/services/address-auto-completion.service';

@Component({
  selector: 'org-structure',
  templateUrl: './manage-org-structure.component.html',
  providers: [OrganisationsService, AccountCodeService],
  styleUrls: ['./manage-org-structure.component.scss'],
})
export class OrgStructureComponent implements OnInit {
  @Input() org_type: string;

  public res: TreeNode[] = [];
  public org_id: number;
  public isLoaded: boolean = false;
  public orgnodes: any = [];
  public selectednodeid: any;
  private _selectedNode: any;
  @Input('selectedNode')
  public set selectedNode(value: any) {
    this._selectedNode = value;
    this.initDepot();
  }

  public get selectedNode(): any {
    return this._selectedNode;
  }

  public depotDlg: boolean = false;
  public teamDlg: boolean = false;
  public regionDlg: boolean = false;
  public dptDlg: boolean = false;
  public invAddrDlg: boolean = false;

  public regionsadd: boolean = false;
  public dptsadd: boolean = false;
  public deptLevelInvoicingEnabled: boolean = false;

  public organisation: any = {};

  public department: any = {};

  public team: any = {};

  public region: any = {};

  public depot: any = {};

  public currentnodetype: any;

  public accountCodes: SelectItem[];
  public costCodes: SelectItem[];
  public customerInvoiceAddresses: IInvoiceAddress[];
  public customerInvoiceAddressesSelect: SelectItem[];
  public selectedAddress: IInvoiceAddress;

  //Forms
  public newDepartmentForm: UntypedFormGroup;
  public newRegionForm: UntypedFormGroup;
  public newTeamForm: UntypedFormGroup;
  public newDepotForm: UntypedFormGroup;

  public currDepartmentForm: UntypedFormGroup;
  public currRegionForm: UntypedFormGroup;
  public currTeamForm: UntypedFormGroup;
  public currDepotForm: UntypedFormGroup;

  //Depot

  public id: number;
  public regionId: number;
  public _name: string;
  @Output() nameChange: EventEmitter<string>;

  @Input('name')
  public set name(value: string) {
    this._name = value;
    this.nameChange.emit(value);
  }

  public get name(): string {
    return this._name;
  }

  public _addressLine1: string;
  @Output() addressLine1Change: EventEmitter<string>;

  @Input('addressLine1')
  public set addressLine1(value: string) {
    this._addressLine1 = value;
    this.addressLine1Change.emit(value);
  }

  public get addressLine1(): string {
    return this._addressLine1;
  }

  public _addressLine2: string;
  @Output() addressLine2Change: EventEmitter<string>;

  @Input('addressLine2')
  public set addressLine2(value: string) {
    this._addressLine2 = value;
    this.addressLine2Change.emit(value);
  }

  public get addressLine2(): string {
    return this._addressLine2;
  }

  public _addressLine3: string;
  @Output() addressLine3Change: EventEmitter<string>;

  @Input('addressLine3')
  public set addressLine3(value: string) {
    this._addressLine3 = value;
    this.addressLine3Change.emit(value);
  }

  public get addressLine3(): string {
    return this._addressLine3;
  }

  public _town: string;
  @Output() townChange: EventEmitter<string>;

  @Input('town')
  public set town(value: string) {
    this._town = value;
    this.townChange.emit(value);
  }

  public get town(): string {
    return this._town;
  }

  public _postCode: string;
  @Output() postCodeChange: EventEmitter<string>;

  @Input('postCode')
  public set postCode(value: string) {
    this._postCode = value;
    this.postCodeChange.emit(value);
  }

  public get postCode(): string {
    return this._postCode;
  }

  public _latitude: number;
  @Output() latitudeChange: EventEmitter<number>;

  @Input('latitude')
  public set latitude(value: number) {
    this._latitude = value;
    this.latitudeChange.emit(value);
  }

  public get latitude(): number {
    return this._latitude;
  }

  public _longitude: number;
  @Output() longitudeChange: EventEmitter<number>;

  @Input('longitude')
  public set longitude(value: number) {
    this._longitude = value;
    this.longitudeChange.emit(value);
  }

  public get longitude(): number {
    return this._longitude;
  }

  public _email: string;
  @Output() emailChange: EventEmitter<string>;

  @Input('email')
  public set email(value: string) {
    this._email = value;
    this.emailChange.emit(value);
  }

  public get email(): string {
    return this._email;
  }

  public _phoneNumber: string;
  @Output() phoneNumberChange: EventEmitter<string>;

  @Input('phoneNumber')
  public set phoneNumber(value: string) {
    this._phoneNumber = value;
    this.phoneNumberChange.emit(value);
  }

  public get phoneNumber(): string {
    return this._phoneNumber;
  }

  public _accountCodeId: number;
  @Output() accountCodeIdChange: EventEmitter<number>;

  @Input('accountCodeId')
  public set accountCodeId(value: number) {
    this._accountCodeId = value;
    this.accountCodeIdChange.emit(value);
  }

  public get accountCodeId(): number {
    return this._accountCodeId;
  }

  public isUserImpersonating = false;

  ///
  msgs: Message[] = [];
  public dptLevelInvoiceInfo: string =
    'Setting this will imply that all orders against this department will be billed to the specified address. Leave blank to always invoice parent organisation';
  public dptInvoiceAddressValid: boolean = true;

  vehicleLifeCycleManageProvidersVisible: boolean = false;
  vehicleLifeCycleProviderUpdateSaving: boolean = false;
  vehicleLifeCycleProviderConnections: IVehicleLifeCycleProviderConnection[] = [];
  vehicleLifeCycleTeamConnections: IVehicleLifeCycleTeamConnection[] = [];
  vehicleLifeCycleTeamProviderFormGroup: UntypedFormGroup;
  vehicleLifeCycleSelectedProvider: IVehicleLifeCycleProviderConnection = null;

  constructor(
    private organisationsService: OrganisationsService,
    private accountCodeService: AccountCodeService,
    private route: ActivatedRoute,
    private mapService: MapService,
    private invoiceAddressService: InvoiceAddressService,
    private userService: UserService,
    private pcaService: PcaService,
    private vehicleLifeCycleService: VehicleLifecycleService,
    private messageService: MessageService,
    private addressAutoCompletionService: AddressAutoCompletionService,
  ) {
    this.nameChange = new EventEmitter<string>();
    this.addressLine1Change = new EventEmitter<string>();
    this.addressLine2Change = new EventEmitter<string>();
    this.addressLine3Change = new EventEmitter<string>();
    this.townChange = new EventEmitter<string>();
    this.postCodeChange = new EventEmitter<string>();
    this.emailChange = new EventEmitter<string>();
    this.phoneNumberChange = new EventEmitter<string>();
    this.accountCodeIdChange = new EventEmitter<number>();
    this.latitudeChange = new EventEmitter<number>();
    this.longitudeChange = new EventEmitter<number>();

    this.userService.isUserImpersonating().then((res) => {
      let resultData: any;
      resultData = res;
      if (resultData != null) {
        this.isUserImpersonating = resultData.isImpersonating;
      } else {
        this.isUserImpersonating = false;
      }
    });
  }

  ngOnInit() {
    const regexp = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
    //FORMS
    //Department
    this.newDepartmentForm = new UntypedFormGroup({
      id: new UntypedFormControl(0, null),
      name: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(100), NoEmptyString]),
      ),
      accountCodeId: new UntypedFormControl(null, null),
      customerId: new UntypedFormControl(0, null),
      invoiceAddressId: new UntypedFormControl(null, null),
      deptLevelInvoicingEnabled: new UntypedFormControl(false, null),
    });

    this.currDepartmentForm = new UntypedFormGroup({
      id: new UntypedFormControl(0, null),
      name: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(100), NoEmptyString]),
      ),
      accountCodeId: new UntypedFormControl(null, null),
      customerId: new UntypedFormControl(0, null),
      invoiceAddressId: new UntypedFormControl(null, null),
      deptLevelInvoicingEnabled: new UntypedFormControl(false, null),
      pickupNotification: new UntypedFormControl(false, null),
      dropoffNotification: new UntypedFormControl(false, null),
      restrictCarryover: new UntypedFormControl(false, null),
      restrictWeekendCarryover: new UntypedFormControl(false, null),
      carryoverAdditionalMileageThreshold: new UntypedFormControl(null, null),
      overrideJobHoldTimings: new UntypedFormControl(false, null),
      minimumBuyItNowHours: new UntypedFormControl(null, integerOrNullValidator()),
      isJobTaggingEnforced: new UntypedFormControl(false, null),
    });

    //Region
    this.newRegionForm = new UntypedFormGroup({
      id: new UntypedFormControl(0, null),
      name: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(100), NoEmptyString]),
      ),
      supplierId: new UntypedFormControl(0, null),
    });

    this.currRegionForm = new UntypedFormGroup({
      id: new UntypedFormControl(0, null),
      name: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(100), NoEmptyString]),
      ),
      supplierId: new UntypedFormControl(0, null),
    });
    //Team
    this.newTeamForm = new UntypedFormGroup({
      id: new UntypedFormControl(0, null),
      name: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(100), NoEmptyString]),
      ),
      accountCodeId: new UntypedFormControl(null, null),
      departmentId: new UntypedFormControl(0, null),
      measureOnTimeOnCollection: new UntypedFormControl(true),
      measureOnTimeOnDelivery: new UntypedFormControl(true),
      primaryContactEmail: new UntypedFormControl(
        '',
        Validators.compose([Validators.email, Validators.required]),
      ),
      secondaryContactEmail: new UntypedFormControl('', Validators.compose([Validators.email])),
    });
    this.currTeamForm = new UntypedFormGroup({
      id: new UntypedFormControl(0, null),
      name: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(100), NoEmptyString]),
      ),
      accountCodeId: new UntypedFormControl(null, null),
      departmentId: new UntypedFormControl(0, null),
      measureOnTimeOnCollection: new UntypedFormControl(true),
      measureOnTimeOnDelivery: new UntypedFormControl(true),
      pickupNotification: new UntypedFormControl(false, null),
      dropoffNotfication: new UntypedFormControl(false, null),
      primaryContactEmail: new UntypedFormControl(
        '',
        Validators.compose([Validators.email, Validators.required]),
      ),
      secondaryContactEmail: new UntypedFormControl('', Validators.compose([Validators.email])),
    });
    //Depot
    this.newDepotForm = new UntypedFormGroup({
      id: new UntypedFormControl(0, null),
      name: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(100), NoEmptyString]),
      ),
      addressLine1: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(255), NoEmptyString]),
      ),
      addressLine2: new UntypedFormControl(
        '',
        Validators.compose([null, Validators.maxLength(255)]),
      ),
      addressLine3: new UntypedFormControl(
        '',
        Validators.compose([null, Validators.maxLength(255)]),
      ),
      town: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(35), NoEmptyString]),
      ),
      postCode: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(8), NoEmptyString]),
      ),
      eMailAddress: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.maxLength(254),
          Validators.pattern(regexp),
        ]),
      ),
      phoneNumber: new UntypedFormControl('', Validators.compose([null, Validators.maxLength(20)])),
      accountCodeId: new UntypedFormControl(null, null),
      regionId: new UntypedFormControl(0, null),
    });
    this.currDepotForm = new UntypedFormGroup({
      id: new UntypedFormControl(0, null),
      name: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(100), NoEmptyString]),
      ),
      addressLine1: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(255), NoEmptyString]),
      ),
      addressLine2: new UntypedFormControl(
        '',
        Validators.compose([null, Validators.maxLength(255)]),
      ),
      addressLine3: new UntypedFormControl(
        '',
        Validators.compose([null, Validators.maxLength(255)]),
      ),
      town: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(35), NoEmptyString]),
      ),
      postCode: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(8), NoEmptyString]),
      ),
      eMailAddress: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.maxLength(254),
          Validators.pattern(regexp),
        ]),
      ),
      phoneNumber: new UntypedFormControl('', Validators.compose([null, Validators.maxLength(20)])),
      accountCodeId: new UntypedFormControl(null, null),
      regionId: new UntypedFormControl(0, null),
    });

    if (this.org_id == undefined) {
      this.accountCodeService.getCurrentUserOrgId().then((res) => {
        this.org_id = res;

        //Load Data
        var that = this;
        this.pcaService.Init().then((result) => {
          that.load();
          that.getAccountCodes();
          that.getInvoiceAddressesForOrganisation(this.org_id);
        });
      });
    }

    this.initLifeCycleProviderForm();
  }

  initAddressAutoCompletionFields(): void {
    const addressSearchFields = [
      { element: 'name', field: '', parentContainer: '', showSavedSites: false },
      { element: 'dAddressLine1', field: '', parentContainer: '', showSavedSites: false },
      { element: 'addressLine2', field: '', parentContainer: '', showSavedSites: false },
      { element: 'town', field: '', parentContainer: '', showSavedSites: false },
      { element: 'city', field: '', parentContainer: '', showSavedSites: false },
      { element: 'postcode', field: '', parentContainer: '', showSavedSites: false },
    ];
  }

  initDepot() {
    try {
      var new_fields = [
        { element: 'new_dName', field: '', parentContainer: '', showSavedSites: false },
        { element: 'new_dAddressLine1', field: '', parentContainer: '', showSavedSites: false },
        { element: 'new_dAddressLine2', field: '', parentContainer: '', showSavedSites: false },
        { element: 'new_dTown', field: '', parentContainer: '', showSavedSites: false },
        { element: 'new_dPostcode', field: '', parentContainer: '', showSavedSites: false },
      ];

      var addressSearchFields = [
        { element: 'dName', field: '', parentContainer: '', showSavedSites: false },
        { element: 'dAddressLine1', field: '', parentContainer: '', showSavedSites: false },
        { element: 'dAddressLine2', field: '', parentContainer: '', showSavedSites: false },
        { element: 'dTown', field: '', parentContainer: '', showSavedSites: false },
        { element: 'dPostcode', field: '', parentContainer: '', showSavedSites: false },
      ];

      this.addressAutoCompletionService.useWithDefaultAddressResponse(
        addressSearchFields,
        (result) => {
          if (result) {
            this.name = result.businessName ?? result.building_name;
            this.addressLine1 = result.line_1;
            this.addressLine2 = result.line_2;
            this.town = result.town_or_city;
            this.postCode = result.postcode;
            this.latitude = result.latitude;
            this.longitude = result.longitude;
          }
        },
      );
      this.addressAutoCompletionService.useWithDefaultAddressResponse(new_fields, (result) => {
        if (result) {
          this.name = result.businessName ?? result.building_name;
          this.addressLine1 = result.line_1;
          this.addressLine2 = result.line_2;
          this.town = result.town_or_city;
          this.postCode = result.postcode;
          this.latitude = result.latitude;
          this.longitude = result.longitude;
        }
      });
    } catch (err) {}
  }

  addteam() {
    this.newTeamForm.patchValue({
      id: 0,
      name: '',
      accountCodeId: null,
      departmentId: this.department.id,
    });
  }

  editteam() {
    this.teamDlg = true;
  }

  adddpt() {
    this.newDepartmentForm.patchValue({
      id: 0,
      name: '',
      accountCodeId: null,
      customerId: this.organisation.id,
    });

    this.dptDlg = true;
  }

  editdpt() {
    this.dptDlg = true;
  }

  addregion() {
    this.newRegionForm.patchValue({
      id: 0,
      name: '',
      supplierId: this.organisation.id,
    });
    this.regionDlg = true;
  }

  editregion() {
    this.regionDlg = true;
  }

  adddepot() {
    this.newDepotForm.patchValue({
      id: 0,
      name: '',
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
      town: '',
      postCode: '',
      eMailAddress: '',
      phoneNumber: '',
      accountCodeId: null,
      regionId: this.region.id,
    });

    this.id = 0;
    this.regionId = this.region.id;
  }

  editdepot() {
    this.depotDlg = true;
  }

  saveNewDepot(FormValues) {
    this.organisationsService
      .updateDepot({
        id: 0,
        name: this.name,
        addressLine1: this.addressLine1,
        addressLine2: this.addressLine2,
        addressLine3: this.addressLine3,
        town: this.town,
        postCode: this.postCode,
        eMailAddress: this.email,
        phoneNumber: this.phoneNumber,
        accountCodeId: this.accountCodeId,
        regionId: this.regionId,
        latitude: this.latitude,
        longitude: this.longitude,
      })
      .then((res) => {
        if (res.errorMsg != '' && res.errorMsg != null) {
          this.depotDlg = false;
          this.msgs.push({ severity: 'error', summary: 'Error', detail: res.errorMsg });
          setTimeout(function () {
            this.msgs = [];
          }, 2000);
        } else {
          this.load();
          if (FormValues.id != 0) {
            this.loadDepot(FormValues.id);
          } else {
            this.selectednodeid.children.push({
              expandenIcon: '',
              label: FormValues.name,
              collapsedIcon: '',
              data: { nodeType: 'Depot' },
            });
          }
          this.depotDlg = false;
        }
      });
  }

  saveDepot(FormValues) {
    this.organisationsService
      .updateDepot({
        id: this.id,
        name: this.name,
        addressLine1: this.addressLine1,
        addressLine2: this.addressLine2,
        addressLine3: this.addressLine3,
        town: this.town,
        postCode: this.postCode,
        eMailAddress: this.email,
        phoneNumber: this.phoneNumber,
        accountCodeId: this.accountCodeId,
        regionId: this.regionId,
        latitude: this.latitude,
        longitude: this.longitude,
      })
      .then((res) => {
        if (res.errorMsg != '' && res.errorMsg != null) {
          this.msgs.push({ severity: 'error', summary: 'Error', detail: res.errorMsg });
          setTimeout(function () {
            this.msgs = [];
          }, 2000);
        } else {
          this.load(); //
          if (FormValues.id != 0) {
            this.loadDepot(FormValues.id);
          } else {
            this.selectednodeid.children.push({
              expandenIcon: '',
              label: FormValues.name,
              collapsedIcon: '',
              data: { nodeType: 'Depot' },
            });
          }
        }
      });
  }

  saveNewTeam(FormValues) {
    console.log('Team form values: ', FormValues);

    this.organisationsService.updateTeam(FormValues).then((res) => {
      if (res.errorMessage) {
        this.msgs.push({ severity: 'error', summary: 'Error', detail: res.errorMessage });
        setTimeout(function () {
          this.msgs = [];
        }, 2000);
      } else {
        this.load();
        if (FormValues.id != 0) {
          this.loadTeam(FormValues.id);
        }
      }
    });
  }

  saveTeam(FormValues) {
    this.organisationsService.updateTeam(FormValues).then((res) => {
      if (res.errorMessage) {
        this.msgs.push({ severity: 'error', summary: 'Error', detail: res.errorMessage });
        setTimeout(function () {
          this.msgs = [];
        }, 2000);
      } else {
        this.load();
        if (this.team.id != 0) {
          this.loadTeam(FormValues.id);
        }
      }
    });
  }

  saveNewRegion(FormValues) {
    this.organisationsService.updateRegion(FormValues).then((res) => {
      if (res.errorMessage) {
        this.regionDlg = false;
        this.msgs.push({ severity: 'error', summary: 'Error', detail: res.errorMessage });
        setTimeout(function () {
          this.msgs = [];
        }, 2000);
      } else {
        this.load();
        if (FormValues.id != 0) {
          this.loadRegion(FormValues.id, true);
        }
        this.regionDlg = false;
      }
    });
  }

  saveRegion(FormValues) {
    this.organisationsService.updateRegion(FormValues).then((res) => {
      if (res.errorMessage) {
        this.msgs.push({ severity: 'error', summary: 'Error', detail: res.errorMessage });
        setTimeout(function () {
          this.msgs = [];
        }, 2000);
      } else {
        this.load();
        if (FormValues.id != 0) {
          this.loadRegion(FormValues.id, true);
        }
      }
    });
  }

  saveNewDepartment(FormValues) {
    this.organisationsService.updateDepartment(FormValues).then((res) => {
      if (res.errorMessage) {
        this.dptDlg = false;
        this.msgs.push({ severity: 'error', summary: 'Error', detail: res.errorMessage });
        setTimeout(function () {
          this.msgs = [];
        }, 2000);
      } else {
        this.load();
        if (FormValues.id != 0) {
          this.loadDepartment(FormValues.id, true);
        }
        this.dptDlg = false;
      }
    });
  }

  saveDepartment(FormValues) {
    if (!this.deptLevelInvoicingEnabled) {
      FormValues.invoiceAddressId = null;
    }
    this.organisationsService.updateDepartment(FormValues).then((res) => {
      if (res.errorMessage) {
        this.msgs.push({ severity: 'error', summary: 'Error', detail: res.errorMessage });
        setTimeout(function () {
          this.msgs = [];
        }, 2000);
      } else {
        this.load();
        if (FormValues.id != 0) {
          this.loadDepartment(FormValues.id, true);
        }
      }
    });
  }

  load() {
    this.organisationsService.structurebyorgid(this.org_id).then((result) => {
      let selectedRootNode: any = result[0];
      this.orgnodes = result.length > 0 ? result[0].children : [];
      this.isLoaded = true;

      if (this.org_type == 'customer') {
        this.orgnodes = this.orgnodes.filter((x) => x.data.nodeType == 'Department');
      } else if (this.org_type == 'supplier') {
        this.orgnodes = this.orgnodes.filter((x) => x.data.nodeType == 'Region');
      }

      this.selectednodeid = this.orgnodes[0];
      this.selectedNode = this.orgnodes[0];

      this.expandAll();
      if (result.length > 0) {
        this.organisationsService.getOrg(selectedRootNode.data.nodeId).then((result) => {
          this.organisation = result;
          this.dptsadd =
            this.organisation.organisationTypeId == 2 || this.organisation.organisationTypeId == 4;
          this.regionsadd =
            this.organisation.organisationTypeId == 3 || this.organisation.organisationTypeId == 4;
        });

        if (this.selectedNode != undefined) {
          this.currentnodetype = this.selectedNode.data.nodeType;
          switch (this.selectedNode.data.nodeType) {
            case 'Region': {
              this.loadRegion(this.selectedNode.data.nodeId, true);
              break;
            }
            case 'Depot': {
              this.loadDepot(this.selectedNode.data.nodeId);
              break;
            }
            case 'Department': {
              this.loadDepartment(this.selectedNode.data.nodeId, true);
              break;
            }
            case 'Team': {
              this.loadTeam(this.selectedNode.data.nodeId);
              break;
            }
            case 'Organisation': {
              this.loadOrganisation(this.selectedNode.data.nodeId);
              this.regionsadd =
                this.selectedNode.data.nodeSubType == 'Supplier' ||
                this.selectedNode.data.nodeSubType == 'Cust + Supp';
              break;
            }
          }
        }
      }
    });
  }

  loadDepot(id: number) {
    const regexp = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
    this.organisationsService.getDepot(id).then((result) => {
      this.depot = result;
      //Populating Current Depot
      this.id = this.depot.id;
      this.name = this.depot.name;
      this.addressLine1 = this.depot.addressLine1;
      this.addressLine2 = this.depot.addressLine2;
      this.addressLine3 = this.depot.addressLine3;
      this.town = this.depot.town;
      this.postCode = this.depot.postCode;
      this.email = this.depot.eMailAddress;
      this.phoneNumber = this.depot.phoneNumber;
      this.accountCodeId = this.depot.accountCodeId;
      this.regionId = this.depot.regionId;
      this.latitude = this.depot.latitude;
      this.longitude = this.depot.longitude;
      this.isLoaded = true;
      this.loadRegion(this.regionId, false);
    });
  }

  loadTeam(id: number) {
    this.organisationsService.getTeam(id).then((result) => {
      this.team = result;
      //Populating Current Team
      this.currTeamForm = new UntypedFormGroup({
        id: new UntypedFormControl(this.team.id, null),
        name: new UntypedFormControl(
          this.team.name,
          Validators.compose([Validators.required, Validators.maxLength(100), NoEmptyString]),
        ),
        accountCodeId: new UntypedFormControl(this.team.accountCodeId, null),
        departmentId: new UntypedFormControl(this.team.departmentId, null),
        pickupNotification: new UntypedFormControl(this.team.pickupNotification, null),
        dropoffNotification: new UntypedFormControl(this.team.dropoffNotification, null),

        measureOnTimeOnCollection: new UntypedFormControl(
          this.team.measureOnTimeOnCollection,
          null,
        ),
        measureOnTimeOnDelivery: new UntypedFormControl(this.team.measureOnTimeOnDelivery, null),
        primaryContactEmail: new UntypedFormControl(
          this.team.primaryContactEmail,
          Validators.compose([Validators.email, Validators.required]),
        ),
        secondaryContactEmail: new UntypedFormControl(
          this.team.secondaryContactEmail,
          Validators.compose([Validators.email]),
        ),
      });

      this.isLoaded = true;
      this.loadDepartment(this.team.departmentId, false);
    });
  }

  loadOrganisation(id: number) {
    this.organisationsService.getOrg(id).then((result) => {
      this.organisation = result;
      this.dptsadd =
        this.organisation.organisationTypeId == 2 || this.organisation.organisationTypeId == 4;
      this.regionsadd =
        this.organisation.organisationTypeId == 3 || this.organisation.organisationTypeId == 4;
      this.isLoaded = true;
    });
  }

  loadDepartment(id: number, isNewTeam: boolean) {
    this.organisationsService.getDepartment(id).then((result) => {
      this.department = result;
      //Populating Current Department
      if (this.department.invoiceAddressId != null) {
        this.deptLevelInvoicingEnabled = true;
      } else {
        this.deptLevelInvoicingEnabled = false;
      }
      this.currDepartmentForm = new UntypedFormGroup({
        id: new UntypedFormControl(this.department.id, null),
        name: new UntypedFormControl(
          this.department.name,
          Validators.compose([Validators.required, Validators.maxLength(100), NoEmptyString]),
        ),
        accountCodeId: new UntypedFormControl(this.department.accountCodeId, null),
        customerId: new UntypedFormControl(this.department.customerId, null),
        invoiceAddressId: new UntypedFormControl(this.department.invoiceAddressId, null),
        deptLevelInvoicingEnabled: new UntypedFormControl(
          this.deptLevelInvoicingEnabled ? 'checked' : false,
          null,
        ),
        pickupNotification: new UntypedFormControl(this.department.pickupNotification, null),
        dropoffNotification: new UntypedFormControl(this.department.dropoffNotification, null),
        restrictCarryover: new UntypedFormControl(this.department.restrictCarryover, null),
        restrictWeekendCarryover: new UntypedFormControl(
          this.department.restrictWeekendCarryover,
          null,
        ),
        carryoverAdditionalMileageThreshold: new UntypedFormControl(
          this.department.carryoverAdditionalMileageThreshold,
          null,
        ),
        overrideJobHoldTimings: new UntypedFormControl(
          this.department.overrideJobHoldTimings,
          null,
        ),
        minimumBuyItNowHours: new UntypedFormControl(
          this.department.minimumBuyItNowHours,
          integerOrNullValidator(),
        ),
        isJobTaggingEnforced: new UntypedFormControl(this.department.isJobTaggingEnforced, null),
      });

      this.isLoaded = true;
      if (isNewTeam) {
        this.addteam();
      }
    });
  }

  loadRegion(id: number, isNewDepot: boolean) {
    this.organisationsService.getRegion(id).then((result) => {
      this.region = result;
      //Populating Current Region
      this.currRegionForm = new UntypedFormGroup({
        id: new UntypedFormControl(this.region.id, null),
        name: new UntypedFormControl(
          this.region.name,
          Validators.compose([Validators.required, Validators.maxLength(100), NoEmptyString]),
        ),
        supplierId: new UntypedFormControl(this.region.supplierId, null),
      });
      this.isLoaded = true;
      if (isNewDepot) {
        this.adddepot();
      }
    });
  }

  nodeSelect(event) {
    this.selectednodeid = event.node;
    this.currentnodetype = event.node.data.nodeType;

    switch (event.node.data.nodeType) {
      case 'Region': {
        this.loadRegion(event.node.data.nodeId, true);
        break;
      }
      case 'Depot': {
        this.loadDepot(event.node.data.nodeId);
        break;
      }
      case 'Department': {
        this.loadDepartment(event.node.data.nodeId, true);
        break;
      }
      case 'Team': {
        this.loadTeam(event.node.data.nodeId);
        break;
      }
      case 'Organisation': {
        this.loadOrganisation(event.node.data.nodeId);
        this.regionsadd =
          event.node.data.nodeSubType == 'Supplier' || event.node.data.nodeSubType == 'Cust + Supp';
        break;
      }
    }

    this.currentnodetype = event.node.data.nodeType;
  }

  getAccountCodes() {
    this.accountCodeService.get().then((result) => {
      this.accountCodes = [];
      this.costCodes = [];

      this.accountCodes.push({ label: 'Select Account Code', value: null });
      this.costCodes.push({ label: 'Select Cost Code', value: null });
      result.forEach((item) => {
        if (item.organisationId == this.org_id) {
          this.accountCodes.push({ label: item.name, value: item.id });
          if (this.org_type == 'customer') {
            this.costCodes.push({ label: item.name, value: item.id });
          }
        }
      });
    });
  }

  getInvoiceAddressesForOrganisation(organisationId: number) {
    this.invoiceAddressService.getForAllOrganisationDepartments(organisationId).then((result) => {
      this.customerInvoiceAddresses = result;
      this.customerInvoiceAddressesSelect = [];
      this.customerInvoiceAddressesSelect.push({ label: 'Select an address', value: null });
      result.forEach((item) => {
        this.customerInvoiceAddressesSelect.push({
          label: item.invoiceCompanyName,
          value: item.id,
        });
      });
    });
  }

  cancelNewDepartment() {
    this.dptDlg = false;
  }

  cancelNewRegion() {
    this.regionDlg = false;
  }

  expandAll() {
    this.orgnodes.forEach((node) => {
      this.expandRecursive(node, true);
    });
  }

  collapseAll() {
    this.orgnodes.forEach((node) => {
      this.expandRecursive(node, false);
    });
  }

  deptLevelInvoicingChanged(event) {
    this.deptLevelInvoicingEnabled = event;
  }

  deptLevelInvoicingAddressChanged(event) {
    if (this.customerInvoiceAddresses && event.value) {
      var selectedAddress = this.customerInvoiceAddresses.filter((x) => x.id == event.value);
      if (selectedAddress) {
        this.selectedAddress = selectedAddress[0];
        this.invAddrDlg = true;
      }
    } else if (!event.value) {
      // nothing was selected in which case, the user no longer wants an invoice address set
      this.dptInvoiceAddressValid = true;
    }
  }

  private expandRecursive(node: TreeNode, isExpand: boolean) {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach((childNode) => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }

  getLifeCycleProviderConnections(): void {
    this.vehicleLifeCycleService.getProviderConnections(this.organisation.id).then((res) => {
      this.vehicleLifeCycleProviderConnections = res;
      this.initLifeCycleProviderForm();
    });
  }

  getLifeCycleTeamConnections(teamId: number): void {
    this.vehicleLifeCycleService.getTeamProviderConnections(teamId).then((res) => {
      this.vehicleLifeCycleTeamConnections = res;
      this.getLifeCycleProviderConnections();
    });
  }

  initLifeCycleProviderForm(teamConfiguration: IVehicleLifeCycleTeamConnection = null): void {
    this.vehicleLifeCycleTeamProviderFormGroup = new UntypedFormGroup({
      id: new UntypedFormControl(teamConfiguration?.id ?? 0),
      providerConnectionId: new UntypedFormControl(teamConfiguration?.providerConnectionId ?? 0),
      teamId: new UntypedFormControl(this.team.id),
      externalTeamId: new UntypedFormControl(
        teamConfiguration?.externalTeamId ?? '',
        Validators.required,
      ),
    });
  }

  configureLifeCycleTeamProviders(teamId: number): void {
    this.vehicleLifeCycleSelectedProvider = null;
    this.getLifeCycleTeamConnections(teamId);
    this.vehicleLifeCycleManageProvidersVisible = true;
  }

  selectProviderConfiguration(connection: IVehicleLifeCycleProviderConnection): void {
    let existingProviderTeamConfiguration = this.vehicleLifeCycleTeamConnections.find(
      (x) => x.providerConnectionId == connection.id,
    );

    if (existingProviderTeamConfiguration) {
      this.initLifeCycleProviderForm(existingProviderTeamConfiguration);
    } else {
      this.initLifeCycleProviderForm();
      this.vehicleLifeCycleTeamProviderFormGroup
        .get('providerConnectionId')
        .setValue(connection.id);
    }
  }

  saveLifeCycleProviderConnection(): void {
    if (
      this.vehicleLifeCycleTeamProviderFormGroup.get('providerConnectionId').value == null ||
      this.vehicleLifeCycleTeamProviderFormGroup.get('providerConnectionId').value == 0
    ) {
      this.messageService.add(Message.Warning('Please select a provider from the list'));
      return;
    }

    this.vehicleLifeCycleProviderUpdateSaving = true;
    this.vehicleLifeCycleService
      .addUpdateTeamProviderConnection(this.vehicleLifeCycleTeamProviderFormGroup.getRawValue())
      .then((res) => {
        this.vehicleLifeCycleTeamConnections = res;
        this.vehicleLifeCycleProviderUpdateSaving = false;
        this.messageService.add(Message.Success('Team updated successfully'));
      })
      .catch((err) => {
        this.vehicleLifeCycleProviderUpdateSaving = false;
      });
  }
}
